import React from 'react';
import HeroSection from '../components/HeroSection';
import ProblemSection from '../components/ProblemSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUs from '../components/WhyChooseUs';
import ImportantNotice from '../components/ImportantNotice';
import HowItWorks from '../components/HowItWorks';
import AreasSection from '../components/AreasSection';
import FinalCTA from '../components/FinalCTA';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import Header from '../components/Header';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white overflow-x-hidden w-full">
      <Header />
      <HeroSection />
      <ProblemSection />
      <AboutSection />
      <ServicesSection />
      <WhyChooseUs />
      <ImportantNotice />
      <HowItWorks />
      <AreasSection />
      <FinalCTA />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;